function windowMessagingReducer(state = {}, action = {}) {
  let newState
  let messages
  switch (action.type) {
    case 'SEND_WINDOW_MESSAGE':
      newState = { ...state }
      return sendMessageHandler(newState, action)
    case 'MARK_WINDOW_MESSAGE_RECEIVED':
      newState = { ...state }
      // the message is read elsewhere... so this simply pops the message off
      // the queue
      if (newState[action.recipient].length > 0) {
        newState[action.recipient] = [...newState[action.recipient]]
        newState[action.recipient].shift()
      }
      return newState
    case 'MARK_ALL_WINDOW_MESSAGES_RECEIVED':
    case 'CLEAR_WINDOW_MESSAGE_QUEUE':
      newState = { ...state }
      newState[action.recipient] = []
      return newState
    // these are interactable action that we need to trigger off of to manage
    // opening and closing of message queues
    case 'FORCE_UPDATE_WIDGET':
    case 'UPDATE_WIDGET':
      // we only care if the window visiblity has changed
      newState = { ...state }
      if(!Array.isArray(action.messages)) {
        messages = action.messages ? [action.messages] : []
      } else {
        messages = [...action.messages]
      }
      
      if (newState[action.window.ref] == null) {
        // window just opened so open a queue for it.
        newState[action.window.ref] = []

        if (messages && messages.length > 0) {
          messages.forEach(message => {
            // the message needs a wrapper (envelope) indicating its recipient, historically this wasn't required
            // when sending a message to an individual widget/window but in order to leverage the same code everywhere
            // I need to create an envelope for the message hat includes the recipient. Since i'm doing this, it doesn't
            // hurt to handle messages with or without envelope.
            const envelope = message.recipient == null ? { recipient: action.window.ref, message } : message
            newState = sendMessageHandler(newState, envelope)
          })
        }

        return newState
      } else if (
        action.window.visible == false &&
        newState[action.window.ref] != null
      ) {
        // window just closed so remove its queue
        delete newState[action.window.ref]
        return newState
      }
      return state
    case 'SET_VIEW': {
      // a screen is all open windows... so basically we are building an
      // entirely new state object here...
      const screen = { ...action.screen }
      messages = [...(action.messages || [])]
      newState = {}
      if (Array.isArray(screen.windows)) {
        if (!action.contextChange && !action.patientChange) {
          screen.windows.forEach(window => {
            // if the window was already open (shared across screens) then
            // we should transfer its queue over (unless its for a different patient)... otherwise open a new queue
            newState[window.ref] =
              state[window.ref] != null ? [...state[window.ref]] : []
          })
        } else {
          screen.windows.forEach(window => {
            newState[window.ref] = []
          })
        }
      } else {
        // this would mean that screen.windows isn't even an array... I dont think that can even
        // happen... certainly not during normal functioning.
      }

      if (messages && messages.length > 0) {
        messages.forEach(message => {
          newState = sendMessageHandler(newState, message)
        })
      }
      return newState
    }
    case 'CLOSE_WIDGET':
      newState = { ...state }
      delete newState[action.ref]
      return newState
    default:
      return state
  }
}

const sendMessageHandler = (nextState, envelope) => {
  const { recipient, message, timestamp, sender } = envelope
  // we support a string recipient or an array of string recipients.
  // If they gave us a string... convert it to an array of one so from
  // here on we can just work with the array

  let recipients = Array.isArray(recipient) ? recipient : [recipient]

  // if the list is empty, then broadcast to all open windows
  if (recipients.length === 0) {
    recipients = Object.keys(nextState)
  }
  recipients.forEach(recipient => {
    if (nextState[recipient] != null) {
      nextState[recipient] = [...nextState[recipient]]
      nextState[recipient].push({
        message: message,
        timestamp: timestamp,
        sender: sender,
        recipient: recipient
      })
    }
  })
  return nextState
}

export default windowMessagingReducer
